/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_Column_CompanyInputs */

const id_staff_resellers_column_company = /** @type {(inputs: Staff_Resellers_Column_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perusahaan`)
};

const en_staff_resellers_column_company = /** @type {(inputs: Staff_Resellers_Column_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Staff_Resellers_Column_CompanyInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_column_company = /** @type {((inputs?: Staff_Resellers_Column_CompanyInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_Column_CompanyInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_column_company(inputs)
	return id_staff_resellers_column_company(inputs)
});